import styles from "./styles.module.css";

export const CGV: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1>Conditions Générales de Vente (CGV)</h1>
      <p className="update-date">Dernière mise à jour : 25/03/2025</p>
      <p>
        Les présentes Conditions Générales de Vente (CGV) régissent l'achat et
        la vente de photocards sur le site
        <a
          href="https://cardonize.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          https://cardonize.com
        </a>
        , une plateforme de marketplace où les utilisateurs peuvent créer,
        acheter, vendre et imprimer des photocards. En utilisant le Site, vous
        acceptez sans réserve les présentes CGV.
      </p>

      <h2>1. Définitions</h2>
      <ul>
        <li>
          <strong>Utilisateur</strong> : Toute personne physique ou morale qui
          utilise le Site pour acheter, vendre ou créer des photocards.
        </li>
        <li>
          <strong>Vendeur</strong> : L'utilisateur qui met en ligne ses photos
          pour créer des photocards destinées à la vente.
        </li>
        <li>
          <strong>Acheteur</strong> : L'utilisateur qui achète une photocard
          créée par un autre utilisateur.
        </li>
        <li>
          <strong>Photocard</strong> : Produit créé à partir d'une image
          téléversée par un utilisateur. Elle peut être physique (imprimée) ou
          numérique.
        </li>
        <li>
          <strong>Booster</strong> : Paquet contenant 6 photocards numériques
          aléatoires. Il n'y a pas de doublon dans un même booster.
        </li>
        <li>
          <strong>Commission</strong> : Pourcentage que le Site perçoit sur
          chaque vente de photocard réalisée.
        </li>
      </ul>

      <h2>2. Objet</h2>
      <p>
        Les présentes CGV ont pour objet de définir les conditions selon
        lesquelles les utilisateurs peuvent acheter et vendre des photocards,
        ainsi que l'impression et l'expédition des photocards réalisées par
        Cardonize (ci-après "l'Entreprise").
      </p>

      <h2>3. Accès au Site</h2>
      <ul>
        <li>
          3.1. Le Site est accessible à toute personne disposant d'une connexion
          Internet. Certaines fonctionnalités peuvent être restreintes selon les
          conditions spécifiques de l'utilisateur.
        </li>
        <li>
          3.2. L'Utilisateur s'engage à fournir des informations exactes lors de
          son inscription et à les mettre à jour.
        </li>
      </ul>

      <h2>4. Création et Vente de Photocards</h2>
      <ul>
        <li>
          4.1. Les utilisateurs peuvent importer des images pour créer des
          photocards. Ces images doivent respecter la loi.
        </li>
        <li>
          4.2. Les utilisateurs peuvent également créer des boosters et les
          vendre à un prix librement fixé.
        </li>
        <li>
          4.3. Le Vendeur garantit avoir les droits nécessaires sur les images
          utilisées.
        </li>
        <li>
          4.4. L'Entreprise prélève une commission de 5% sur les ventes
          numériques, en plus des frais de transaction.
        </li>
        <li>4.5. Une commission de 80% s'applique sur les ventes imprimées.</li>
      </ul>

      <h2>5. Achat de Photocards</h2>
      <ul>
        <li>
          5.1. L'Acheteur peut acheter des boosters via le processus de
          commande.
        </li>
        <li>5.2. Chaque booster contient 6 cartes aléatoires sans doublon.</li>
        <li>
          5.3. Les paiements se font via les méthodes disponibles sur le Site.
        </li>
      </ul>

      <h2>6. Processus d'Impression et d'Expédition</h2>
      <ul>
        <li>
          6.1. L'impression est assurée par l'Entreprise sur du papier photo
          brillant (6.3cm x 8.8cm).
        </li>
        <li>
          6.2. Les photocards sont livrées à l'adresse fournie, frais à la
          charge de l'Acheteur sauf exception.
        </li>
        <li>
          6.3. L'Entreprise ne peut être tenue responsable des retards dus à des
          événements extérieurs.
        </li>
      </ul>

      <h2>7. Paiement et Facturation</h2>
      <ul>
        <li>
          7.1. Les paiements sont sécurisés et gérés par l’Entreprise pour le
          compte des Vendeurs.
        </li>
        <li>
          7.2. Les frais de douane et taxes sont à la charge de l'Acheteur si
          applicables.
        </li>
      </ul>

      <h2>8. Droit de Rétractation et Retours</h2>
      <ul>
        <li>
          8.1. Droit de rétractation de 14 jours à réception de la commande.
        </li>
        <li>
          8.2. En cas de problème de qualité, un échange ou remboursement est
          possible sous 14 jours.
        </li>
      </ul>

      <h2>9. Propriété Intellectuelle</h2>
      <ul>
        <li>
          9.1. L'Utilisateur conserve la propriété des images, sous réserve des
          droits d'exploitation accordés.
        </li>
        <li>
          9.2. L'Entreprise peut utiliser les images à des fins promotionnelles,
          avec accord préalable.
        </li>
      </ul>

      <h2>10. Responsabilité</h2>
      <ul>
        <li>
          10.1. L'Entreprise n'est pas responsable des erreurs ou omissions
          présentes sur le Site.
        </li>
        <li>
          10.2. L'Utilisateur est responsable des contenus qu'il publie et de
          son usage du Site.
        </li>
      </ul>

      <h2>11. Modification des CGV</h2>
      <p>
        L'Entreprise peut modifier ces CGV à tout moment. L'utilisation continue
        du Site vaut acceptation.
      </p>

      <h2>12. Loi Applicable et Litiges</h2>
      <p>
        Les CGV sont régies par la loi française. En cas de litige, les parties
        chercheront une solution amiable. À défaut, les tribunaux compétents de
        [ville ou région, France] seront saisis.
      </p>

      <h2>13. Retrait de Contenu et Absence de Remboursement</h2>
      <ul>
        <li>
          13.1. En cas de non-respect des CGV/CGU, le contenu concerné pourra
          être retiré sans préavis.
        </li>
        <li>
          13.2. Aucun remboursement ne sera effectué pour les contenus retirés
          pour non-conformité.
        </li>
      </ul>

      <h2>14. Droit de Rétractation et Produits Scellés</h2>
      <p>
        Conformément à l'article L221-28 du Code de la consommation, le droit de
        rétractation ne s'applique pas aux produits scellés qui, une fois
        ouverts, ne peuvent être retournés (ex. : cartes mystères), sauf défaut
        de conformité ou vice caché.
      </p>
    </div>
  );
};
